import React from "react";
import logoschool from "../../assets/images/logosignup.png";
import { useNavigate } from "react-router-dom";
const NewPassword =()=>{
const navigate =  useNavigate();
    return(<>
    
    <div className="school-pages-inner">
        <div className="school-content-page">
        {/* <img src={logoschool}/>  */}
            <img
          src={logoschool}
          alt="School Logo"
          style={{  cursor: "pointer" }}
          onClick={() => navigate("/school")}
        />
        <div className="schoo-outer">
            <div className="school-outer-pages forget-passw">
            <h2>Enter New Password</h2>

            <div className="input-container comfirm-pass">
        <input type="email"
	
			  placeholder=" "
			/>
        <label >New Password</label>
		
    </div>
    <div className="input-container ">
        <input type="email"
	
			  placeholder=" "
			/>
        <label >Confirm Password</label>
		
    </div>

            <button className="continue-btn">CONTINUE</button>
            <p className="login-account" onClick={()=>navigate("/login-page")} >Back to Login</p>

            <p className="term-part" >
	  <a href="#" >Terms of Use</a>  |  <a href="#" >Privacy Policy</a>
	</p>
            </div>

        </div>

        </div>

    </div>

    
    
    </>);

}
export default NewPassword;